import React from 'react';
import { useStore } from '../../stores';
import { observer } from 'mobx-react-lite';
import { Layers, Modals } from '../../stores/layers';

export const Favourites = observer(() => {
  const { config, layers, favourites, myLocations } = useStore();
  const savedPoisLength = favourites.list?.length + myLocations?.list?.length;

  return config.features.favourites ? (
    <div
      className="bg-white w-12 h-12 ml-2 cursor-pointer relative flex items-center justify-center text-neutral-500 text-xl rounded-full shadow-md transition-all"
      onClick={() => {
        favourites?.list?.length || myLocations?.list?.length
          ? layers.openLayer(Layers.favourites)
          : layers.openModal(Modals.noFavourites);
      }}
    >
      {savedPoisLength ? (
        <span className="bg-success w-5 h-5 flex justify-center items-center text-white text-xs rounded-full shadow absolute -bottom-1 right-0">
          <span className="text-xs">
            {savedPoisLength}
          </span>
        </span>
      ) : null}
      <span className="icon icon-heart text-2xl text-brand-3" />
    </div>
  ) : null;
});
